import * as _ from 'lodash';
import { State, RouteState } from '../reducers';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PlColumnState, IPlColumnEntry } from '../pl.types';
import * as fromPlColumn from '../reducers/pl-column.reducer';

export const getRouteState = createFeatureSelector<State, RouteState>('pl');

export const selectPlColumnState = createSelector(
    getRouteState,
    ({ apiColumn }): PlColumnState => apiColumn
  );

export const selectPlColumns = createSelector(
  selectPlColumnState,
  fromPlColumn.selectAll
);
